/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PlatformSubsidiary
 */
export interface PlatformSubsidiary {
    /**
     * 
     * @type {string}
     * @memberof PlatformSubsidiary
     */
    subsidiaryId: string;
    /**
     * 
     * @type {string}
     * @memberof PlatformSubsidiary
     */
    name: string;
    /**
     * 
     * @type {Set<string>}
     * @memberof PlatformSubsidiary
     */
    availableCurrencies: Set<string>;
}

/**
 * Check if a given object implements the PlatformSubsidiary interface.
 */
export function instanceOfPlatformSubsidiary(value: object): value is PlatformSubsidiary {
    if (!('subsidiaryId' in value) || value['subsidiaryId'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('availableCurrencies' in value) || value['availableCurrencies'] === undefined) return false;
    return true;
}

export function PlatformSubsidiaryFromJSON(json: any): PlatformSubsidiary {
    return PlatformSubsidiaryFromJSONTyped(json, false);
}

export function PlatformSubsidiaryFromJSONTyped(json: any, ignoreDiscriminator: boolean): PlatformSubsidiary {
    if (json == null) {
        return json;
    }
    return {
        
        'subsidiaryId': json['subsidiaryId'],
        'name': json['name'],
        'availableCurrencies': json['availableCurrencies'],
    };
}

export function PlatformSubsidiaryToJSON(value?: PlatformSubsidiary | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'subsidiaryId': value['subsidiaryId'],
        'name': value['name'],
        'availableCurrencies': Array.from(value['availableCurrencies'] as Set<any>),
    };
}

